import { Fragment } from "react";
import {
  IconNameEnum,
  useFlightStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Icon } from "@b2bportal/core-ui";
import clsx from "clsx";
import defaultStyles from "./FlightTime.module.scss";

export interface FlightTimeComponentProps extends PlatformComponentProps {
  departureTime: string;
  arrivalTime: string;
  stops: number;
}

export const FlightTime = ({
  departureTime,
  arrivalTime,
  className,
  children,
  stops,
}: FlightTimeComponentProps) => {
  const COMPNENT_KEY = CoreFlightsComponent.FlightTime;
  const styles = useFlightStyles(COMPNENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPNENT_KEY);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("time", { "departure-time": true })}>
        {departureTime}
      </div>
      <div className={cn("flight-time-icon")}>-</div>
      <div className={clsx(cn("time", { "arrival-time": true }))}>
        {arrivalTime}
      </div>
      {children}
    </div>
  );
};
